import React from "react";
import classNames from "classnames/bind";
import styles from "./WithdrawalOfMembership.module.scss";

const cx = classNames.bind(styles);

const BottomMenu = [
  {
    id: 1,
    name: "제휴 문의",
  },
  {
    id: 2,
    name: "앱 오류사항",
  },
  {
    id: 3,
    name: "결제 서비스 관련",
  },
  {
    id: 4,
    name: "서비스 불만족",
  },
];

export default function WithdrawalOfMembership({
  removeReason,
  handleChagne,
  handleSubmit,
}) {
  return (
    <div className={cx("container")}>
      <div className={cx("inner")}>
        <p className={cx("title")}>회원탈퇴</p>
        <div className={cx("select-box")}>
          <select
            value={removeReason}
            onChange={handleChagne}
            name="removeReason"
          >
            {BottomMenu.map((item) => (
              <option key={item.id} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        {/* {removeReason === "기타" && (
          <div className={cx("textarea-box")}>
            <textarea
              name="removeReason"
              placeholder="탈퇴 사유를 입력해주세요."
            />
          </div>
        )} */}
        <div className={cx("button-box")}>
          <button onClick={handleSubmit} className={cx("button")}>
            회원탈퇴
          </button>
        </div>
      </div>
    </div>
  );
}
